import React from 'react';
import { useNavigate } from 'react-router-dom';
import { initializeUserData } from '../services/firestoreService';

const UserSelection = () => {
  const navigate = useNavigate();
  
  // Users available in the system
  const users = [
    { name: 'Monika', color: 'bg-pink-500 hover:bg-pink-600' },
    { name: 'Prajwal', color: 'bg-blue-500 hover:bg-blue-600' }
  ];

  // Handle user selection
  const handleUserSelect = async (userName) => {
    try {
      // Initialize user data in Firestore if it doesn't exist
      await initializeUserData(userName);
      
      // Navigate to the user's calendar view
      navigate(`/calendar/${userName}`);
    } catch (error) {
      console.error('Error selecting user:', error);
      alert('Error selecting user. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-pink-50 flex items-center justify-center p-4">
      <div className="max-w-lg w-full lg:max-w-2xl">
        {/* Header */}
        <div className="text-center mb-12">
          {/* Logo */}
          <div className="mb-6 flex justify-center">
            <div className="relative">
              <img 
                src="/homepage-logo.png" 
                alt="SIDDHI Logo" 
                className="w-32 h-32 sm:w-40 sm:h-40 md:w-44 md:h-44 lg:w-48 lg:h-48 object-cover drop-shadow-lg transition-all duration-300 hover:scale-105 rounded-full border-4 border-white shadow-xl"
              />
            </div>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 leading-tight">
            SIDDHI - A Co-Working Tracker tool
          </h1>
          <p className="text-gray-600 text-lg">
            Select your user to start tracking daily work
          </p>
        </div>

        {/* User Selection Cards */}
        <div className="space-y-4">
          {users.map((user) => (
            <button
              key={user.name}
              onClick={() => handleUserSelect(user.name)}
              className={`w-full p-8 rounded-2xl text-white font-semibold text-xl 
                         shadow-lg transform transition-all duration-200 
                         hover:scale-105 active:scale-95 ${user.color}`}
            >
              <div className="flex items-center justify-center space-x-3">
                {/* User Avatar */}
                <div className="w-12 h-12 bg-white bg-opacity-30 rounded-full flex items-center justify-center">
                  <span className="text-2xl">
                    {user.name.charAt(0)}
                  </span>
                </div>
                <span>{user.name}</span>
              </div>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div className="text-center mt-12">
          <p className="text-gray-500 text-sm">
            Real-time work tracking for Prajwal & Monika
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserSelection;
